import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import Checkbox from '../../../../../FlyfishComponents/Checkbox';
import {
	EcomcheckedBox,
	EcomUntickBox,
} from '../../../../../FlyfishComponents/flyfishIcons/icons';
import { array, option, string } from 'yargs';
import Axios from 'axios';
import Slider from '@mui/material/Slider';
import { Tooltip } from '@mui/material';
import {
	getCurrencySymbol,
	loadStateSession,
	saveStateSession,
	NumberFormattinginLocale,
} from '../../../../../FlyfishComponents/flyfishutils/utils';
const ResultTitle = styled.div`
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
overflow: hidden;
}
`;
const SliderContainer = styled.div`
	margin-left: 10px;
	.MuiSlider-root {
		width: 90%;
	}
	.MuiSlider-thumb {
		color: var(--secondary-color-ff-secondary400);
		background-color: #fff;
		border: 6px solid var(--secondary-color-ff-secondary400);
		box-shadow: none !important;
	}
	.MuiSlider-track {
		height: 4px;
		color: var(--secondary-color-ff-secondary400);
	}
	.MuiSlider-rail {
		height: 8px;
		background-color: #d9d9d9;
	}
	.price-slider-container {
		width: 300px;
		margin: 20px;
	}

	.slider-values {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.slider {
		height: 8px;
		background: #d9d9d9; /* Full track background */
		border-radius: 5px;
		position: relative;
		flex-grow: 1;
	}

	.slider-track {
		background: rgba(248, 49, 188, 0.3); /* Highlight only between thumbs */
		height: 8px;
		border-radius: 5px;
	}

	.slider-thumb {
		height: 20px;
		width: 20px;
		background-color: rgba(248, 49, 188, 1);
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		top: -6px;
	}

	.slider-labels {
		display: flex;
		justify-content: space-between;
		font-size: 0.9rem;
		margin-top: 0px;
		color: var(--black-60);
		margin-left: -6px;
		margin-right: 12px;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 21px;
	}
`;
const EcomFilterContent = styled.div`
// border-right: 1px solid var(--black-10, rgba(0, 0, 0, 0.10));
width: 100%;
height: 100vh;
.ff-see-more{
	color: var(--secondary-color-ff-secondary500);
    font-size: 14px;
    margin-left: 36px;
    margin-top: -12px;
	cursor:pointer;
}
.ff-filter-border{
	border-top: 1px solid var(--black-10, rgba(0, 0, 0, 0.10));
	width: 90%;
    margin-top: 16px;
}
.ff-checkbox-filter.hide{
	display:none;
}
.ff-checkbox-filter{
	margin-bottom: 8px;
	
	.ff-checkbox {
		>label{
			justify-content: flex-start;
    align-items: flex-start;
		}

			.ff-chatbot-body2{
				color: var(--black-60);
				margin: 2px 0px;
				text-transform: capitalize;
			}
		}
	}
}
.ff-filter-radio{
	padding-left: 16px;
    overflow-y: auto;
	overflow-x: hidden;
	margin-bottom:98px;
	>div{
		&:nth-of-type(1){
			padding-bottom: 10px;
		}
	}
	.ff-filter-title{
		color:var(--primary-color-ff-primary900);
		font-size:14px;
		letter-spacing: 0.42px;
		margin-top: 8px;
		margin-bottom: 8px;
		text-transform: capitalize;
	}
}
	> div {
		&:nth-of-type(1) {
			display: flex;
			justify-content: space-between;
			border-bottom: 1.5px solid #c6c4c463;
			padding-bottom: 10px;
			padding-left: 15px;
			padding-top: 10px;
			padding-right: 15px;
			> div {
				&:nth-of-type(2) {
					color: var(--primary-color-ff-primary500);
					font-weight: 500;
				}
			}
		}
	}
	> .ff-filter-radio {
		@media screen and (max-width: 800px) {
			height: calc(100vh - 106px);
		}
		.css-1hbvpl3-MuiSvgIcon-root,
		.css-11zohuh-MuiSvgIcon-root {
			width: 18px;
			height: 18px;
		}
		.css-j204z7-MuiFormControlLabel-root {
			display: flex;
			margin-top: -18px;
		}
		.css-j204z7-MuiFormControlLabel-root .MuiFormControlLabel-label {
			white-space: nowrap;
			> .ff-chatbot-body2 {
				font-weight: 500;
				font-size: 14px !important;
			}
		}
		.css-vqmohf-MuiButtonBase-root-MuiRadio-root {
			color: var(--primary-color-ff-primary500);
		}
		.css-vqmohf-MuiButtonBase-root-MuiRadio-root.Mui-checked {
			color: var(--primary-color-ff-primary500);
		}
		.ff-see-more-ecom {
			font-size: 14px;
			color: var(--primary-color-ff-primary500);
			margin-top: 0px;
			margin-bottom: 12px;
			font-weight: 500;
		}
		.ff-filter-type-parent {
			border-top: 1.5px solid #c6c4c463;
			padding-top: 13px;
			padding-left: 14px;
			.ff-checkbox {
				margin-top: -18px;
			}
			> div {
				&:nth-of-type(1) {
					font-size: 16px;
					font-weight: 500;
					margin-bottom: 18px;
				}
			}
			&:first-child {
				border: none !important;
			}
		}
	}
	.ff-categories-filter {
		margin-top: 20px;
		.ff-checkbox {
			margin-bottom: -23px;
		}
		> div {
			&:nth-of-type(1) {
				margin-top: 40px;
				font-weight: 500;
				font-size: 16px;
			}
		}
	}
`;
type Props = {
	queryText: string;
	id;
	msgId;
	filterData;
	handleFilter;
	productCount;
	currency;
	uploadedImage;
	resultMessage;
	isLogoPassed;
};

const EcomFilter = ({
	queryText,
	id,
	msgId,
	filterData,
	handleFilter,
	productCount,
	currency,
	uploadedImage,
	resultMessage,
	isLogoPassed,
}: Props) => {
	const [gender, setGender] = useState(['Men', 'Women', 'Girl', 'Boy']);
	const [selectedGender, setSelectedGender] = useState('');
	const [enableSeeMore, setEnableSeeMore] = useState<any>('');

	const [storeFilter, setStoreFilter] = useState<any>([]);
	const [changed, setChanged] = useState(false);
	const [selectedData, setSelctedData] = useState<any>([]);
	const [priceRange, setPriceRange] = useState<number[]>(null);
	const [filterSelected, setFilterSelected] = useState(false);

	const [selectedFilters, setSelectedFilters] = useState({});
	const [seeMoreOption, setSeeMoreOption] = useState([]);
	const handleCheckboxChange = (filterCaption, value) => {
		setFilterSelected(true);
		setSelectedFilters((prevFilters) => {
			const currentValues = prevFilters[filterCaption] || [];
			if (currentValues.includes(value)) {
				// Remove value if already selected
				let updatedFilters = {
					...prevFilters,
					[filterCaption]: currentValues.filter((item) => item !== value),
				};
				if (updatedFilters[filterCaption].length === 0) {
					delete updatedFilters[filterCaption];
				}
				return updatedFilters;
			} else {
				// Add value if not selected
				return {
					...prevFilters,
					[filterCaption]: [...currentValues, value],
				};
			}
		});
	};
	useEffect(() => {
		let updatedData;
		if (filterSelected) {
			if (Object.keys(selectedFilters).length !== 0) {
				const priceFilter = filterData.find((item) =>
					item.hasOwnProperty('price')
				)
					? filterData.find((item) => item.hasOwnProperty('price')).price
					: filterData.find((item) => item.hasOwnProperty('sale_price'))
							.sale_price;
				const keyName = filterData.find((item) => item.hasOwnProperty('price'))
					? 'price'
					: 'sale_price';
				updatedData = {
					...selectedFilters,
					[keyName.toString()]: {
						min: priceRange ? priceRange[0] : priceFilter.min,
						max: priceRange ? priceRange[1] : priceFilter.max,
					},
				};
			} else {
				if (filterSelected) {
					updatedData = {};
				}
			}
			saveStateSession('filters', updatedData);
			handleFilter(updatedData);
		}
	}, [selectedFilters]);
	// useEffect(() => {
	// 	if (!(JSON.parse(sessionStorage.getItem('filters')) && Object.keys(JSON.parse(sessionStorage.getItem('filters'))).length === 0 && JSON.parse(sessionStorage.getItem('filters')).constructor === Object)) {
	// 		setPriceRange([JSON.parse(sessionStorage.getItem('filters')).price.min, JSON.parse(sessionStorage.getItem('filters')).price.max])
	// 	}
	// }, [])

	return (
		<>
			{!uploadedImage ? (
				<div
					style={
						isLogoPassed
							? {
									marginBottom: '-34px',
									paddingLeft: '15px',
									marginTop: '4px',
							  }
							: {
									marginBottom: '16px',
									paddingLeft: '15px',
									// marginTop: "-48px",
							  }
					}
				>
					<Tooltip title={resultMessage}>
						<ResultTitle className='ff-result-title ff-chatbot-body2'>
							Showing results for{' '}
							<span style={{ fontWeight: '700' }}>{resultMessage}</span>
						</ResultTitle>
					</Tooltip>
					<div
						className='ff-chatbot-caption'
						style={{
							color: 'var(--black-50, rgba(0, 0, 0, 0.50))',
							marginTop: '3px',
						}}
					>{`${productCount} products found`}</div>
				</div>
			) : null}

			<EcomFilterContent>
				<div
					style={
						isLogoPassed
							? {
									borderRight: '1px solid var(--black-10, rgba(0, 0, 0, 0.10))',
									paddingTop: '52px',
									borderBottom: 'none',
							  }
							: { border: 'none' }
					}
				>
					<div
						className='ff-chatbot-body1'
						style={{
							color: 'var(--color-scale-1, #1C0047)',
							border: 'none',
							fontWeight: '600',
							letterSpacing: '0.32px',
						}}
					>
						Filters
					</div>
					{priceRange || storeFilter.length > 0 ? (
						<div
							className='ff-chatbot-body1'
							style={{
								color: 'var(--secondary-color-ff-secondary400)',
								border: 'none',
								letterSpacing: '0.32px',
								cursor: 'pointer',
							}}
							onClick={() => {
								if (
									filterData.find(
										(item) =>
											item.hasOwnProperty('price') ||
											item.hasOwnProperty('sale_price')
									)
								) {
									let price =
										(filterData.find((item) => item.hasOwnProperty('price')) &&
											filterData.find((item) => item.hasOwnProperty('price'))
												.price) ||
										filterData.find((item) => item.hasOwnProperty('sale_price'))
											.sale_price;
									let minPrice = price.min;
									let maxPrice = price.max;
									setPriceRange(null);
								}
								setSelectedFilters({});
								setStoreFilter([]);
								saveStateSession('filters', {});
							}}
						>
							Clear all
						</div>
					) : null}
				</div>
				<div
					className='ff-filter-radio'
					style={{
						height: !uploadedImage
							? isLogoPassed
								? 'calc(100% - 160px)'
								: 'calc(100% - 120px)'
							: 'calc(100% - 500px)',
						borderRight: isLogoPassed
							? '1px solid var(--black-10, rgba(0, 0, 0, 0.10))'
							: 'none',
					}}
				>
					<div>
						{filterData &&
							filterData.map((filter, index) => {
								const filterCaption = filter.filter_caption;
								const options =
									filter[
										Object.keys(filter).filter(
											(item) => item !== 'filter_caption'
										)[0]
									];
								const payloadKey = Object.keys(filter).filter(
									(item) => item !== 'filter_caption'
								)[0];
								const priceKey = filter.price
									? 'price'
									: filter.sale_price
									? 'sale_price'
									: '';
								return (
									<>
										<div key={filterCaption} style={{ marginBottom: '20px' }}>
											<div
												className='ff-chatbot-body1 ff-filter-title'
												style={{ fontWeight: '600' }}
											>
												{filterCaption}
											</div>

											{priceKey === 'price' || priceKey === 'sale_price' ? (
												<SliderContainer className='ff-slider-container'>
													<Slider
														aria-labelledby='range-slider'
														onChangeCommitted={(event, newValue) => {
															// if (newValue[0] + 200 <= newValue[1]) {
															let updatedData;
															updatedData = {
																...selectedFilters,
																[priceKey.toString()]: {
																	min: newValue[0],
																	max: newValue[1],
																},
															};

															setFilterSelected(true);
															setSelectedFilters(updatedData);
															// }
														}}
														step={200}
														value={
															priceRange
																? priceRange
																: [
																		filter.price
																			? filter.price.min
																			: filter.sale_price.min,
																		filter.price
																			? filter.price.max
																			: filter.sale_price.max,
																  ]
														}
														onChange={(event, newValue) => {
															// if (newValue[0] + 200 <= newValue[1]) {
															setPriceRange(newValue as number[]);
															// }
														}}
														min={
															filter.price
																? filter.price.min
																: filter.sale_price.min
														}
														max={
															filter.price
																? filter.price.max
																: filter.sale_price.max
														}
													/>
													<div className='slider-labels'>
														<span>
															{getCurrencySymbol(currency)}
															{NumberFormattinginLocale(
																Math.floor(
																	Number(
																		priceRange
																			? priceRange[0]
																			: filter.price
																			? filter.price.min
																			: filter.sale_price.min
																	)
																)
															)}
														</span>
														<span>
															{getCurrencySymbol(currency)}
															{NumberFormattinginLocale(
																Math.floor(
																	Number(
																		priceRange
																			? priceRange[1]
																			: filter.price
																			? filter.price.max
																			: filter.sale_price.max
																	)
																)
															)}
														</span>
													</div>
												</SliderContainer>
											) : (
												options &&
												options
													.sort((a, b) => a.value.localeCompare(b.value))
													.map((option, index) => (
														<div
															key={option.value}
															className={`ff-checkbox-filter ${
																index >= 5 &&
																!seeMoreOption.includes(filterCaption)
																	? 'hide'
																	: 'show'
															}`}
														>
															<Checkbox
																fill={'var(--secondary-color-ff-secondary500)'}
																label={
																	<p className='ff-chatbot-body2'>
																		{option.value}
																		{/* {` (${option.count})`} */}
																	</p>
																}
																isChecked={
																	storeFilter.includes(
																		option.value + filterCaption
																	)
																		? [true]
																		: [false]
																}
																index={0}
																onValueChange={(item) => {
																	if (item[0] === true) {
																		saveStateSession('storeFilter', [
																			...storeFilter,
																			option.value + filterCaption,
																		]);
																		setStoreFilter([
																			...storeFilter,
																			option.value + filterCaption,
																		]);
																	} else {
																		saveStateSession(
																			'storeFilter',
																			storeFilter.filter(
																				(item) =>
																					item !== option.value + filterCaption
																			)
																		);
																		setStoreFilter(
																			storeFilter.filter(
																				(item) =>
																					item !== option.value + filterCaption
																			)
																		);
																	}
																	handleCheckboxChange(
																		payloadKey,
																		option.value
																	);
																}}
															/>
														</div>
													))
											)}
										</div>
										{/* {filterData.length - 1 !== index && ( */}
										<>
											{options.length >= 5 &&
												options.length - 5 !== 0 &&
												!seeMoreOption.includes(filterCaption) && (
													<div
														className='ff-see-more'
														onClick={() => {
															setSeeMoreOption([
																filterCaption,
																...seeMoreOption,
															]);
														}}
													>
														{options.length - 5} more
													</div>
												)}
											{filterData.length - 1 !== index && (
												<div className='ff-filter-border'></div>
											)}
										</>
										{/*  */}
									</>
								);
							})}
					</div>
				</div>
			</EcomFilterContent>
		</>
	);
};

export default EcomFilter;
